import en from "ra-language-english";

export default {
  ...en,
  rules: {
    name: "Rule |||| Rules",
    menu: "Rules",
    create: {
      title: "Create a Rule",
    },
    edit: {
      title: "Edit Rule",
    },
    list: {
      title: "Rules",
    },
    fields: {
      id: "Id",
      name: {
        label: "Name",
        helper: "The name of the rule",
      },
      rate: {
        label: "Rate",
        helper: "The rate of the rule",
      },
      countriesFrom: {
        label: "Countries From",
        helper: "The countries from of the rule, separated by commas",
      },
      countriesTo: {
        label: "Countries To",
        helper: "The countries to of the rule, separated by commas",
      },
      sellersLabel: {
        label: "Sellers Label",
        helper: "The sellers label of the rule, separated by commas",
      },
      statesTo: {
        label: "States To",
        helper: "The states label of the rule, separated by commas if needed",
      },
      madeInCountries: {
        label: "Made In Countries",
        helper: "The made in countries label, separated by commas if needed",
      },
      threshold: {
        label: "Threshold",
        helper: "The threshold of the rule if needed",
      },
      currencyCode: {
        label: "Currency",
        helper: "The currency of the rule if needed",
      },
      titles: {
        ruleDetails: "Rule Details",
        countries: "Countries",
        sellers: "Sellers",
        statesTo: "States To",
        madeInCountries: "Made In Countries",
        threshold: "Threshold",
        currencyCode: "Currency",
      },
    },
  },
  rulesDeemedSupplier: {
    menu: "Deemed Supplier",
    create: {
      title: "Create a Rule Deemed Supplier",
    },
    edit: {
      title: "Edit Rule Deemed Supplier",
    },
    list: {
      title: "Rules Deemed Supplier",
    },
    fields: {
      generalInfo: "General Information",
      countries: "Countries",
      financialInfo: "Financial Information",
      name: {
        label: "Rule Name",
        helper: "Enter the name of the deemed supplier rule.",
      },
      threshold: {
        label: "Threshold",
        helper: "Enter the threshold value for this rule.",
      },
      taxIdentifier24s: {
        label: "Tax Identifier 24s",
        helper: "Enter the 24s tax identifier.",
      },
      taxIdentifierName: {
        label: "Tax Identifier Name",
        helper: "Enter the name of the tax identifier.",
      },
      countriesFrom: {
        label: "Countries From",
        helper: "List the countries of origin, separated by commas.",
      },
      countriesTo: {
        label: "Countries To",
        helper: "List the destination countries, separated by commas.",
      },
      exceptCountriesFrom: {
        label: "Except Countries From",
        helper: "List any countries to exclude, separated by commas.",
      },
      currency: {
        label: "Currency",
        helper: "Select the currency for this rule.",
      },
      sapAccount1: {
        label: "SAP Account 1",
        helper: "Enter the primary SAP account.",
      },
      sapAccount2: {
        label: "SAP Account 2",
        helper: "Enter the secondary SAP account (optional).",
      },
    },
  },
};
